import React, { Component } from 'react';
import {  Route, withRouter, Switch } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import { connect } from 'react-redux';
import $ from "jquery";

import Header from 'partials/Header';
import Footer from 'partials/Footer';
import routes from 'routes';
import WP from 'WP'; 

import { setRouteTransitionState } from 'store';
     
if(process.env.NODE_ENV === 'development') {
    console.log('WP:',WP);
}

class App extends Component {

    _blured() {
        const max768 = window.matchMedia("(max-width: 768px)").matches;
        return this.props.searchBlur && !max768 ? 'blured blured-on-search' : 'blured-on-search';
    }

    componentDidMount() {

        // fix for internal links created in WP editor
        const self = this;
        document.addEventListener('click', function(e) {
            if(e.target.tagName === 'A') {
                const href = e.target.getAttribute('href');
                if(href && href.indexOf(WP.base_url) !== -1) {
                    e.preventDefault();
                    let fixedHref = href.replace(WP.base_url, '');
                    if(fixedHref[0] !== '/') fixedHref = '/'+fixedHref;
                    self.props.history.push(fixedHref);
                }
            }
        }, false);

        /*setInterval(function() {
            console.log($(window).innerHeight(), $(window).outerHeight(), $('#root').innerHeight(), $('#root').outerHeight());
        }, 500);*/
    }

    _onTransitionEnter() {
        this.props.setRouteTransitionState('enter');
        $('#root').scrollTop(0);
    }

    _onTransitionEntered() {
        this.props.setRouteTransitionState('entered');
    }


    render() {

        const { location } = this.props;

        return (
            <Wrapper>

                <Header />

                <ViewsWrapper className={this._blured.bind(this)()}>
                    <CSSTransition key={location.key} onEnter={this._onTransitionEnter.bind(this)} onEntered={this._onTransitionEntered.bind(this)} classNames='route' timeout={window.matchMedia("(max-width: 768px)").matches ?  0 : 1000}>
                        <Switch location={location}>
                            {routes.map((route, i) => {
                                const { path, component, exact } = route;

                                if(Array.isArray(path))
                                    return path.map((path, i) => <Route key={i} exact={exact} path={path} component={component} /> )
                                
                                return <Route key={i} exact={exact} path={path} component={component} />
                            })}
                        </Switch>
                    </CSSTransition>
                </ViewsWrapper>

                <Footer />

            </Wrapper>
        );
    }
}

const mapStateToProps = state => {
    return {
        searchBlur: state.searchBlur,
    }
}

const actions = {
    setRouteTransitionState
}

export default withRouter(connect(mapStateToProps, actions)(App));

const Wrapper = styled.div`
    position: relative;
    min-height: 100vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    @media(max-width: 768px) {
        padding-top:100px;
        min-height: auto;
        height: auto;
    }
`
const ViewsWrapper = styled(TransitionGroup)`
    flex:1 0 auto;
    display:flex;
    position:relative;

    .route-exit {
        position:absolute;
        transition: all .3s ease-out;
        opacity:1;
        top:0;
    }
    .route-exit-active {
        opacity:0;
    }
    
    .route-enter {
        top:0;
        position:absolute;
        transition: all .8s ease-out;
        opacity:0;
        transform: translateY(100px);
        z-index: 100;
        @media (max-width:480px) {
            top:auto;
            position:relative;
            transition: none;
            opacity:1;
            transform: none;
        }
    }
    .route-enter-active {
        opacity:1;
        transform: translateY(0);
    }
`



// WEBPACK FOOTER //
// ./src/App.js